import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Heading } from 'components/chroma';

interface PictureProps {
  src: string;
  heading?: string;
}
const CenteredImage = styled.img`
  max-width: 352px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const MarginDiv = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;
export const OptionImage: FunctionComponent<PictureProps> = ({
  src,
  heading,
}) => (
  <MarginDiv>
    {heading && <Heading size={4}>{heading}</Heading>}
    <CenteredImage src={src} alt={`${heading} graphic`} aria-hidden />
  </MarginDiv>
);

export default OptionImage;
